import React, { Component } from 'react';
import { withStyles, Drawer } from '@material-ui/core/';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SidebarTitle from '../Title/SidebarTitle'
import clsx from 'clsx'

const styles = theme => ({
    SwipeableDrawer: {
        '& .MuiDrawer-paperAnchorRight': {
            background: '#FAFAFA '
        }
    },
    fullList: {
        width: 'auto',
    },
    formContainer: {
        padding: '0 24px',
        backgroundColor: '#FAFAFA ',
        height: '100%',
        maxWidth: '480px'
    },
    closeIcon: {
        transform: "scale(0.68)",
        float: "right",
        cursor: "pointer"
    },
    HeaderForm: {
        padding: '15px 24px 15px 24px',
        borderBottom: '1px solid #E6EDF5',
        backgroundColor: 'white',
        width: '100%'
    },
});

class sideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    render() {
        const { classes, className, open, handleDrawerClose, title, icon, children } = this.props;
        return (
            <Drawer
                anchor="right"
                open={open}
                onClose={handleDrawerClose}
                className={clsx(classes.SwipeableDrawer, classes.drawer)}
            >
                <div
                    id='sidebar'
                    tabIndex={-1}
                    className={clsx(className, classes.list)}
                >
                    {title ?
                        <div className={classes.HeaderForm} >
                            <SidebarTitle
                                title={title}
                                icon={icon}
                            />
                            <div className={classes.closeIcon} onClick={handleDrawerClose}>
                                <FontAwesomeIcon color="#BABABA" icon={['fal', 'times']} size="2x" />
                            </div>
                        </div>
                        : ''}
                    {children}
                </div>
            </Drawer>
        )
    }
}
export default withStyles(styles)(sideMenu);